let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4l34J")).then(() => parcelRequire('7eBQO'));